import { Col, Container, Row } from "react-bootstrap";
import ClubCard from "./ClubCard";

// import MeetGreetandTalkCropanduseleft from "../../../images/SoulTree/ClubConnect/MeetGreetandTalkCropanduseleft.webp";
// import MinglemixLaughCropuseleftside from "../../../images/SoulTree/ClubConnect/MinglemixLaughCropuseleftside.webp";
// import PlayandEnjoy from "../../../images/SoulTree/ClubConnect/PlayandEnjoy.webp";
// import Relaxrejuvenate from "../../../images/SoulTree/ClubConnect/Relaxrejuvenate.webp";
// import UniteCelebrateCropuserightside from "../../../images/SoulTree/ClubConnect/UniteCelebrateCropuserightside.webp";

// import clubhouse1 from "../../../images/Soulace/clubconnect/image 7.webp";
// import clubhouse6 from "../../../images/Soulace/clubconnect/Image 25.webp";
// import clubhouse2 from "../../../images/Soulace/clubconnect/Image 26.webp";
// import clubhouse4 from "../../../images/Soulace/clubconnect/Image 27.webp";
// import clubhouse5 from "../../../images/Soulace/clubconnect/Image 28.webp";
// import clubhouse3 from "../../../images/Soulace/clubconnect/Image 29.webp";
// import clubhouse7 from "../../../images/Soulace/clubconnect/Image 30.webp";
import NextArrow from "../../../images/Common/NextArrow.svg";
import PrevArrow from "../../../images/Common/PrevArrow.svg";

import SwiperCore, {
    A11y,
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Heading } from "../../Global/Typography";

const clubhouse1 =
    "/images/SereneHeights/clubconnect/badminton-and-squash.webp";
const clubhouse2 = "/images/SereneHeights/clubconnect/swimming-pool.webp";
const clubhouse3 = "/images/SereneHeights/clubconnect/table-tennis.webp";
const clubhouse4 = "/images/SereneHeights/clubconnect/board-games.webp";
const clubhouse5 = "/images/SereneHeights/clubconnect/gym.webp";
const clubhouse6 = "/images/SereneHeights/clubconnect/party-hall.webp";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export default function Clubs({ inView }) {
    // const BlocksData = [
    //   {
    //     title: "Meet, Greet & Talk",
    //     label:
    //       "From lobbies of the living areas, various seating clusters in & around the project to the corridor spaces there are various thoughtfully designed ‘pause points’ to incorporate enthusiastic welcomes and lingering goodbyes. Wholesome architectural enhancements for you to meet, greet & talk.",
    //     image: MeetGreetandTalkCropanduseleft,
    //   },
    //   {
    //     title: "Mingle, Mix & Laugh",
    //     label:
    //       "Soul Tree is sprinkled with an array of open spaces including dedicated senior citizen seating areas meant to merge the social and the personal with group-friendly and quiet spaces. The green patch between the living areas is created with landscapes – lush greenery interspersed with seating facilities and calming water bodies where you can mingle, mix & laugh.",
    //     image: MinglemixLaughCropuseleftside,
    //   },
    //   {
    //     title: "Play & Enjoy",
    //     label:
    //       "With multiple kids-play areas scattered around the project & specifically designed toddlers play areas toddlers play areas accompanied by parents seating benches. we aim to cater to the demands of each & every age group. There is a Basket Ball Court, motorised Cricket net, Skating & Biking Ring and so much more for you to play & enjoy to the fullest.",
    //     image: PlayandEnjoy,
    //   },
    //   {
    //     title: "Relax & Rejuvenate",
    //     label:
    //       "It’s a space that is designed to serve today’s global lifestyles and new-age living. Reflexology Barefoot Paths with Pebbles are meant to give you a relaxing break from your hectic lifestyle while the elevated east-facing sunrise court, Yoga zone, various green parks including a butterfly garden, walking path, multiple outdoor gyms & around the project jogging path will help you to relax & rejuvenate.",
    //     image: Relaxrejuvenate,
    //   },
    //   {
    //     title: "Unite & Celebrate",
    //     label:
    //       "Soul Tree lends its name from a rare auspicious banyan tree centring the Amphi Theatre space a uniquely designed space to encourage the celebrations of every nature. Adding to an already impressive Clubhouse packed with world-class facilities & the project dedicated to giving you a cause to unite & celebrate life every day.",
    //     image: UniteCelebrateCropuserightside,
    //   },
    // ];
    const BlocksData = [
        {
            title: "Badminton & Squash",
            label: "Stay active and competitive with our Badminton and Squash courts.",
            image: clubhouse1,
            imgAlt: "Badminton & Squash",
        },
        {
            title: "Swimming Pool",
            label: "Dive into relaxation, perfect for leisurely swims or energizing workouts.",
            image: clubhouse2,
            imgAlt: "Swimming Pool",
        },
        {
            title: "Table Tennis",
            label: "Enjoy a lively match with your neighbors or bond with your children over an exciting game.",
            image: clubhouse3,
            imgAlt: "Table Tennis",
        },
        {
            title: "Board Games",
            label: "Gather your friends and family for a fun-filled session of board games.",
            image: clubhouse4,
            imgAlt: "Board Games",
        },
        {
            title: "Gym",
            label: "Designed for both beginners and fitness enthusiasts alike, achieve any fitness goals with ease.",

            image: clubhouse5,
            imgAlt: "Gym",
        },
        {
            title: "Party Hall",
            label: "Host unforgettable celebrations and gatherings, perfect for creating cherished moments with family and friends.",
            image: clubhouse6,
            imgAlt: "Party Hall",
        },
    ];

    return (
        <>
            <Container className="Blocks-Container Blocks-Container--ClubsContainter">
                <Row className="pb-5 mb-5">
                    <Col xs={12} className="pl-4 pl-md-5 ml-md-5 px-0 pr-md-0">
                        <div className="Blocks__Slider">
                            <Swiper
                                className="BlocksSlider"
                                id="BlocksSlider"
                                tag="section"
                                wrapperTag="ul"
                                speed={400}
                                spaceBetween={10}
                                autoplay={true}
                                loop={true}
                                keyboard={{
                                    enabled: true,
                                }}
                                onSwiper={(swiper) => console.log(swiper)}
                                // onSlideChange={(swiper) =>
                                //   console.log("slide index changed to: ", swiper.activeIndex)
                                // }
                                onInit={(swiper) =>
                                    console.log("Swiper initialized", swiper)
                                }
                                breakpoints={{
                                    300: {
                                        slidesPerView: 1.4,
                                        spaceBetween: 20,
                                    },
                                    450: {
                                        slidesPerView: 2.1,
                                        spaceBetween: 20,
                                    },

                                    768: {
                                        slidesPerView: 3.1,
                                        spaceBetween: 20,
                                    },
                                    1024: {
                                        slidesPerView: 4.1,
                                        spaceBetween: 20,
                                    },
                                    1300: {
                                        slidesPerView: 4.2,
                                        spaceBetween: 38,
                                    },
                                }}
                                pagination={{
                                    clickable: true,
                                    el: ".swiper-pagination-Clubs",
                                }}
                                navigation={{
                                    prevEl: ".ArrowButtonBlock__ArrowPrevArchitech",
                                    nextEl: ".ArrowButtonBlock__ArrowNextArchitech",
                                }}
                            >
                                {BlocksData.map((item, index) => (
                                    <SwiperSlide tag="li" key={index}>
                                        <ClubCard item={item} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </Col>
                </Row>

                <Row className="ArrowButtons">
                    <div className="ArrowButtonBlock">
                        <div className="swiper-pagination swiper-pagination-Clubs"></div>
                        <div className="ArrowButtonBlock__Arrow ArrowButtonBlock__ArrowPrevArchitech d-none">
                            <img
                                src={PrevArrow}
                                className="-image"
                                alt="ArchitecturalSlider"
                            />
                        </div>
                        <div className="ArrowButtonBlock__Arrow ArrowButtonBlock__ArrowNextArchitech d-none">
                            <img
                                src={NextArrow}
                                className="-image"
                                alt="ArchitecturalSlider"
                            />
                        </div>
                    </div>
                </Row>
            </Container>
        </>
    );
}
